import CryptoJS from 'crypto-js';

export function encrypt(data){
    if(typeof(data) != "string"){
        data = JSON.stringify(data);
    }

    const cipherText = CryptoJS.AES.encrypt(data, process.env.REACT_APP_CRYPTO);
    console.log(cipherText);

    return cipherText;
}

export function decrypt(cipherText){
    const bytes = CryptoJS.AES.decrypt(cipherText, process.env.REACT_APP_CRYPTO);
    var originalText = bytes.toString(CryptoJS.enc.Utf8);
    
    console.log(originalText);

    return originalText;
}

export function validateSriLankanMobileNumber(mobile){
    const phoneNumberRegex = /^\+947\d{8}$/;
    return phoneNumberRegex.test(mobile);
}

export function getDate(d){
    const date = new Date(d);

    const year = date.getFullYear();

    let month = date.getMonth() + 1;
    month = month < 10 ? `0${month}` : month;

    let day = date.getDay();
    day = day < 10 ? `0${day}` : day;

    return `${year}-${month}-${day}`;
}

export function numberWithCommas(x) {
    if(x){
        return x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
    }

    return "";
}

export function sentenceCase(label){
    const givenValue = "" + label.trim();

    if(givenValue.length === 0){
        return "";
    }

    if(givenValue.length > 1){
        return `${givenValue[0].toUpperCase()}${givenValue.substring(1)}`;
    }
    else{
        return givenValue.toUpperCase();
    }
}

export function GetMonth(month){
    switch(month){
        case 0:
            return "January"
        case 1:
            return "February"
        case 2:
            return "March"
        case 3:
            return "April"
        case 4:
            return "May"
        case 5:
            return "June"
        case 6:
            return "July"
        case 7:
            return "August"
        case 8:
            return "September"
        case 9:
            return "October"
        case 10:
            return "November"
        case 11:
            return "December"
    }
}

export function getFileExtension(file) {
    if (file && file.name) {
        const fileNameParts = file.name.split(".");

        if (fileNameParts.length > 1) {
            return `.${fileNameParts[fileNameParts.length - 1]}`;
        }
    }
    
    return "";
}

export function base64ToFile(base64Data, filename) {
    const arr = base64Data.split(',');
    const mimeMatch = arr[0].match(/:(.*?);/);
    const mime = mimeMatch ? mimeMatch[1] : '';
    const bstr = atob(arr[1]);
    let n = bstr.length;
    const u8arr = new Uint8Array(n);

    while (n--) {
        u8arr[n] = bstr.charCodeAt(n);
    }

    return new File([u8arr], filename, { type: mime });
}